import Vue from 'vue';
import VueCompositionApi, { onMounted, onUnmounted, ref, readonly, computed, unref, h, inject, watchEffect, watchPostEffect, watch as watch$1, provide, toRaw, nextTick, getCurrentInstance } from '@vue/composition-api';
import { createEditor, $getRoot, $createParagraphNode, $getSelection, TextNode, $createTextNode, $isTextNode, $isElementNode, $isLineBreakNode, COMMAND_PRIORITY_LOW, INSERT_PARAGRAPH_COMMAND, $isLeafNode, $getPreviousSelection, $isRangeSelection, $setSelection, $isRootNode, $getNodeByKey, DELETE_CHARACTER_COMMAND, DELETE_WORD_COMMAND, MOVE_TO_END, DELETE_LINE_COMMAND, KEY_TAB_COMMAND, OUTDENT_CONTENT_COMMAND, INDENT_CONTENT_COMMAND, COMMAND_PRIORITY_EDITOR, KEY_ENTER_COMMAND, KEY_ESCAPE_COMMAND, KEY_ARROW_UP_COMMAND, COMMAND_PRIORITY_NORMAL, KEY_ARROW_DOWN_COMMAND, DEPRECATED_$isGridSelection, KEY_SPACE_COMMAND, $getNearestNodeFromDOMNode, KEY_ARROW_LEFT_COMMAND, ElementNode, $applyNodeReplacement } from 'lexical';
import { $canShowPlaceholderCurry } from '@lexical/text';
import { mergeRegister, $findMatchingParent, addClassNamesToElement } from '@lexical/utils';
import { registerDragonSupport } from '@lexical/dragon';
import { registerRichText, $createHeadingNode, $createQuoteNode } from '@lexical/rich-text';
import { AutoLinkNode, $isAutoLinkNode, $isLinkNode, $createAutoLinkNode } from '@lexical/link';
import { INSERT_ORDERED_LIST_COMMAND, insertList, INSERT_UNORDERED_LIST_COMMAND, REMOVE_LIST_COMMAND, removeList, $handleListInsertParagraph, $isListNode, INSERT_CHECK_LIST_COMMAND, $isListItemNode } from '@lexical/list';
import { createEmptyHistoryState, registerHistory } from '@lexical/history';
import { $createCodeNode } from '@lexical/code';
import { registerMarkdownShortcuts, TRANSFORMERS } from '@lexical/markdown';
import { $isMarkNode } from '@lexical/mark';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var script$f = {
  provide: function provide() {
    return {
      editor: this.editor
    };
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var HISTORY_MERGE_OPTIONS = {
      tag: 'history-merge'
    };
    function initializeEditor(editor, initialEditorState) {
      if (initialEditorState === null) {
        return;
      }
      if (initialEditorState === undefined) {
        editor.update(function () {
          var root = $getRoot();
          if (root.isEmpty()) {
            var paragraph = $createParagraphNode();
            root.append(paragraph);
            var activeElement = document.activeElement;
            if ($getSelection() !== null || activeElement !== null && activeElement === editor.getRootElement()) paragraph.select();
          }
        }, HISTORY_MERGE_OPTIONS);
      } else if (props.initialConfig.initialEditorState !== null) {
        switch (_typeof(initialEditorState)) {
          case 'string':
            {
              var parsedEditorState = editor.parseEditorState(initialEditorState);
              editor.setEditorState(parsedEditorState, HISTORY_MERGE_OPTIONS);
              break;
            }
          case 'object':
            {
              editor.setEditorState(initialEditorState, HISTORY_MERGE_OPTIONS);
              break;
            }
          case 'function':
            {
              editor.update(function () {
                var root = $getRoot();
                if (root.isEmpty()) initialEditorState(editor);
              }, HISTORY_MERGE_OPTIONS);
              break;
            }
        }
      }
    }
    var editor = createEditor({
      editable: props.initialConfig.editable,
      namespace: props.initialConfig.namespace,
      nodes: props.initialConfig.nodes,
      theme: props.initialConfig.theme,
      onError: function onError(error) {
        emit('error', error);
      }
    });
    initializeEditor(editor, props.initialConfig.editorState);
    onMounted(function () {
      var isEditable = props.initialConfig.editable;
      editor.setEditable(isEditable || false);
    });
    return {
      editor: editor
    };
  },
  props: {
    initialConfig: {
      namespace: '',
      nodes: [],
      editable: true,
      editorState: undefined
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  }
  // Vue.extend constructor export interop.
  const options = typeof script === 'function' ? script.options : script;
  // render functions
  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true;
    // functional template
    if (isFunctionalTemplate) {
      options.functional = true;
    }
  }
  // scopedId
  if (scopeId) {
    options._scopeId = scopeId;
  }
  let hook;
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context = context ||
      // cached call
      this.$vnode && this.$vnode.ssrContext ||
      // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      }
      // inject component styles
      if (style) {
        style.call(this, createInjectorSSR(context));
      }
      // register component module identifier for async chunk inference
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }
  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      const originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      const existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return script;
}

const isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
  const group = isOldIE ? css.media || 'default' : id;
  const style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });
  if (!style.ids.has(id)) {
    style.ids.add(id);
    let code = css.source;
    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
      // http://stackoverflow.com/a/26603875
      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }
    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }
      HEAD.appendChild(style.element);
    }
    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      const index = style.ids.size - 1;
      const textNode = document.createTextNode(code);
      const nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

/* script */
const __vue_script__$h = script$f;

/* template */
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_vm._t("default")], 2)
};
var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;

  /* style */
  const __vue_inject_styles__$h = function (inject) {
    if (!inject) return
    inject("data-v-424f6ac6_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalComposer.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$h = undefined;
  /* module identifier */
  const __vue_module_identifier__$h = undefined;
  /* functional template */
  const __vue_is_functional_template__$h = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$h = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    createInjector,
    undefined,
    undefined
  );

/**
 * @internal
 */
function useMounted(cb) {
    let unregister;
    onMounted(() => {
        unregister = cb();
    });
    onUnmounted(() => {
        unregister === null || unregister === void 0 ? void 0 : unregister();
    });
}

function canShowPlaceholderFromCurrentEditorState(editor) {
    return editor
        .getEditorState()
        .read($canShowPlaceholderCurry(editor.isComposing()));
}
function useCanShowPlaceholder(editor) {
    const initialState = editor
        .getEditorState()
        .read($canShowPlaceholderCurry(editor.isComposing()));
    const canShowPlaceholder = ref(initialState);
    function resetCanShowPlaceholder() {
        canShowPlaceholder.value = canShowPlaceholderFromCurrentEditorState(editor);
    }
    useMounted(() => {
        return mergeRegister(editor.registerUpdateListener(() => {
            resetCanShowPlaceholder();
        }), editor.registerEditableListener(() => {
            resetCanShowPlaceholder();
        }));
    });
    return readonly(canShowPlaceholder);
}

function useRichTextSetup(editor) {
    useMounted(() => {
        return mergeRegister(registerRichText(editor), registerDragonSupport(editor));
    });
}

function l(e) {
  return e instanceof Element;
}
function o(e) {
  return typeof e == "string";
}
const n = {
  name: "Teleport",
  props: {
    to: [String, Element]
  },
  mounted() {
    const e1 = this.to;
    const toEL = l(e1) ? e1 : o(e1) && e1 !== "" ? document.querySelector(e1) : null;
    if (this.$el && this.$el.parentElement !== toEL && toEL !== null) {
      toEL.appendChild(this.$el);
    }
  },
  destroyed() {
    this.$el.remove();
  },
  methods: {},
  render() {
    var e, t;
    return (t = (e = this.$scopedSlots).default) == null ? void 0 : t.call(e);
  }
};
n.install = function (e, {
  prefix: t = ""
} = {}) {
  e.component(t + n.name, n);
};

function useDecorators(editor) {
    const decorators = ref({});
    useMounted(() => {
        const listen = (nextDecorators) => {
            decorators.value = nextDecorators;
        };
        editor._listeners.decorator.add(listen);
        decorators.value = editor.getDecorators();
        return () => {
            editor._listeners.decorator.delete(listen);
        };
    });
    // Return decorators defined as Vue Teleports
    return computed(() => {
        const decoratedTeleports = [];
        const decoratorKeys = Object.keys(unref(decorators));
        for (let i = 0; i < decoratorKeys.length; i++) {
            const nodeKey = decoratorKeys[i];
            const vueDecorator = decorators.value[nodeKey];
            const element = editor.getElementByKey(nodeKey);
            if (element !== null) {
                /**
                 * createElement
                 * instance.$createElement.apply(instance, args)
                 * _createElement
                 * 根据extractPropsFromVNodeData函数知道这里要加props
                 * initRender
                 * 当前问题：mountComponent处能够发现vueDecorator成为了一个comment注释
                 */
                const teleport = h(n, {
                    props: {
                        to: element,
                    },
                }, [vueDecorator]);
                decoratedTeleports.push(teleport);
            }
        }
        return decoratedTeleports;
    });
}

function useEditor() {
    const editor = inject('editor');
    if (!editor)
        throw new Error('<LexicalComposer /> is required');
    return editor;
}

/**
 * @internal
 */
function useEffect(cb, options) {
    watchEffect((onInvalidate) => {
        const unregister = cb();
        onInvalidate(() => unregister === null || unregister === void 0 ? void 0 : unregister());
    }, Object.assign({ flush: 'post' }, options));
}

function findFirstMatch(text, matchers) {
    for (let i = 0; i < matchers.length; i++) {
        const match = matchers[i](text);
        if (match)
            return match;
    }
    return null;
}
const PUNCTUATION_OR_SPACE = /[.,;\s]/;
function isSeparator(char) {
    return PUNCTUATION_OR_SPACE.test(char);
}
function endsWithSeparator(textContent) {
    return isSeparator(textContent[textContent.length - 1]);
}
function startsWithSeparator(textContent) {
    return isSeparator(textContent[0]);
}
function isPreviousNodeValid(node) {
    let previousNode = node.getPreviousSibling();
    if ($isElementNode(previousNode))
        previousNode = previousNode.getLastDescendant();
    return (previousNode === null
        || $isLineBreakNode(previousNode)
        || ($isTextNode(previousNode)
            && endsWithSeparator(previousNode.getTextContent())));
}
function isNextNodeValid(node) {
    let nextNode = node.getNextSibling();
    if ($isElementNode(nextNode))
        nextNode = nextNode.getFirstDescendant();
    return (nextNode === null
        || $isLineBreakNode(nextNode)
        || ($isTextNode(nextNode) && startsWithSeparator(nextNode.getTextContent())));
}
function isContentAroundIsValid(matchStart, matchEnd, text, node) {
    const contentBeforeIsValid = matchStart > 0
        ? isSeparator(text[matchStart - 1])
        : isPreviousNodeValid(node);
    if (!contentBeforeIsValid)
        return false;
    return matchEnd < text.length
        ? isSeparator(text[matchEnd])
        : isNextNodeValid(node);
}
function handleLinkCreation(node, matchers, onChange) {
    const nodeText = node.getTextContent();
    let text = nodeText;
    let invalidMatchEnd = 0;
    let remainingTextNode = node;
    let match;
    // eslint-disable-next-line no-cond-assign
    while ((match = findFirstMatch(text, matchers))) {
        const matchStart = match.index;
        const matchLength = match.length;
        const matchEnd = matchStart + matchLength;
        const isValid = isContentAroundIsValid(invalidMatchEnd + matchStart, invalidMatchEnd + matchEnd, nodeText, node);
        if (isValid) {
            let linkTextNode;
            if (invalidMatchEnd + matchStart === 0) {
                [linkTextNode, remainingTextNode] = remainingTextNode.splitText(invalidMatchEnd + matchLength);
            }
            else {
                [, linkTextNode, remainingTextNode] = remainingTextNode.splitText(invalidMatchEnd + matchStart, invalidMatchEnd + matchStart + matchLength);
            }
            const linkNode = $createAutoLinkNode(match.url, match.attributes);
            const textNode = $createTextNode(match.text);
            textNode.setFormat(linkTextNode.getFormat());
            textNode.setDetail(linkTextNode.getDetail());
            linkNode.append(textNode);
            linkTextNode.replace(linkNode);
            onChange(match.url, null);
            invalidMatchEnd = 0;
        }
        else {
            invalidMatchEnd += matchEnd;
        }
        text = text.substring(matchEnd);
    }
}
function handleLinkEdit(linkNode, matchers, onChange) {
    // Check children are simple text
    const children = linkNode.getChildren();
    const childrenLength = children.length;
    for (let i = 0; i < childrenLength; i++) {
        const child = children[i];
        if (!$isTextNode(child) || !child.isSimpleText()) {
            replaceWithChildren(linkNode);
            onChange(null, linkNode.getURL());
            return;
        }
    }
    // Check text content fully matches
    const text = linkNode.getTextContent();
    const match = findFirstMatch(text, matchers);
    if (match === null || match.text !== text) {
        replaceWithChildren(linkNode);
        onChange(null, linkNode.getURL());
        return;
    }
    // Check neighbors
    if (!isPreviousNodeValid(linkNode) || !isNextNodeValid(linkNode)) {
        replaceWithChildren(linkNode);
        onChange(null, linkNode.getURL());
        return;
    }
    const url = linkNode.getURL();
    if (url !== match.url) {
        linkNode.setURL(match.url);
        onChange(match.url, url);
    }
    if (match.attributes) {
        const rel = linkNode.getRel();
        if (rel !== match.attributes.rel) {
            linkNode.setRel(match.attributes.rel || null);
            onChange(match.attributes.rel || null, rel);
        }
        const target = linkNode.getTarget();
        if (target !== match.attributes.target) {
            linkNode.setTarget(match.attributes.target || null);
            onChange(match.attributes.target || null, target);
        }
    }
}
// Bad neighbours are edits in neighbor nodes that make AutoLinks incompatible.
// Given the creation preconditions, these can only be simple text nodes.
function handleBadNeighbors(textNode, onChange) {
    const previousSibling = textNode.getPreviousSibling();
    const nextSibling = textNode.getNextSibling();
    const text = textNode.getTextContent();
    if ($isAutoLinkNode(previousSibling) && !startsWithSeparator(text)) {
        replaceWithChildren(previousSibling);
        onChange(null, previousSibling.getURL());
    }
    if ($isAutoLinkNode(nextSibling) && !endsWithSeparator(text)) {
        replaceWithChildren(nextSibling);
        onChange(null, nextSibling.getURL());
    }
}
function replaceWithChildren(node) {
    const children = node.getChildren();
    const childrenLength = children.length;
    for (let j = childrenLength - 1; j >= 0; j--)
        node.insertAfter(children[j]);
    node.remove();
    return children.map(child => child.getLatest());
}
function useAutoLink(editor, matchers, onChange) {
    useEffect(() => {
        if (!editor.hasNodes([AutoLinkNode])) {
            throw new Error('LexicalAutoLinkPlugin: AutoLinkNode not registered on editor');
        }
        const onChangeWrapped = (url, prevUrl) => {
            if (onChange)
                onChange(url, prevUrl);
        };
        return mergeRegister(editor.registerNodeTransform(TextNode, (textNode) => {
            const parent = textNode.getParentOrThrow();
            if ($isAutoLinkNode(parent)) {
                handleLinkEdit(parent, unref(matchers), onChangeWrapped);
            }
            else if (!$isLinkNode(parent)) {
                if (textNode.isSimpleText())
                    handleLinkCreation(textNode, unref(matchers), onChangeWrapped);
                handleBadNeighbors(textNode, onChangeWrapped);
            }
        }), editor.registerNodeTransform(AutoLinkNode, (linkNode) => {
            handleLinkEdit(linkNode, unref(matchers), onChangeWrapped);
        }));
    });
}

function useList(editor) {
    useMounted(() => {
        return mergeRegister(editor.registerCommand(INSERT_ORDERED_LIST_COMMAND, () => {
            insertList(editor, 'number');
            return true;
        }, COMMAND_PRIORITY_LOW), editor.registerCommand(INSERT_UNORDERED_LIST_COMMAND, () => {
            insertList(editor, 'bullet');
            return true;
        }, COMMAND_PRIORITY_LOW), editor.registerCommand(REMOVE_LIST_COMMAND, () => {
            removeList(editor);
            return true;
        }, COMMAND_PRIORITY_LOW), editor.registerCommand(INSERT_PARAGRAPH_COMMAND, () => {
            const hasHandledInsertParagraph = $handleListInsertParagraph();
            if (hasHandledInsertParagraph) {
                return true;
            }
            return false;
        }, COMMAND_PRIORITY_LOW));
    });
}

function useHistory(editor, externalHistoryState, delay) {
    const historyState = computed(() => unref(externalHistoryState) || createEmptyHistoryState());
    watchPostEffect((onInvalidate) => {
        const unregisterListener = registerHistory(unref(editor), historyState.value, unref(delay) || 1000);
        onInvalidate(() => {
            unregisterListener();
        });
    });
}

function $wrapNodes(selection, createElement, wrappingElement) {
    var _a, _b;
    const nodes = selection.getNodes();
    const nodesLength = nodes.length;
    const anchor = selection.anchor;
    if (nodesLength === 0
        || (nodesLength === 1
            && anchor.type === 'element'
            && anchor.getNode().getChildrenSize() === 0)) {
        const target = anchor.type === 'text'
            ? anchor.getNode().getParentOrThrow()
            : anchor.getNode();
        const children = target.getChildren();
        let element = createElement();
        element.setFormat(target.getFormatType());
        element.setIndent(target.getIndent());
        children.forEach(child => element.append(child));
        if (wrappingElement)
            element = wrappingElement.append(element);
        /*
            * 踩坑：第一行的__parent为空，导致页面报错
            * 方法1：为target添加parent，会进入死循环，放弃
            * 方法2：在第一行后面添加element，再删除第一行，假如存在多行（即$getRoot().getChildren().length不为1，则需要遍历倒插元素），解决问题
            * 疑惑：为什么第一行的__parent为空？
            * */
        if (!target.__parent) {
            let delete_length = 1;
            while (delete_length !== $getRoot().getChildren().length) {
                if (delete_length === 1) {
                    $getRoot().append(element);
                    $getRoot().selectEnd();
                }
                else {
                    $getRoot().append($getRoot().getChildren()[1]);
                    $getRoot().selectStart();
                }
                delete_length++;
            }
            if ($getRoot().getChildren().length === 1) {
                $getRoot().append(element);
                $getRoot().selectEnd();
                (_a = $getRoot().getFirstChild()) === null || _a === void 0 ? void 0 : _a.remove();
            }
            else {
                (_b = $getRoot().getFirstChild()) === null || _b === void 0 ? void 0 : _b.remove();
            }
        }
        else {
            target.replace(element);
        }
        return;
    }
    let topLevelNode = null;
    let descendants = [];
    for (let i = 0; i < nodesLength; i++) {
        const node = nodes[i];
        // Determine whether wrapping has to be broken down into multiple chunks. This can happen if the
        // user selected multiple Root-like nodes that have to be treated separately as if they are
        // their own branch. I.e. you don't want to wrap a whole table, but rather the contents of each
        // of each of the cell nodes.
        if ($isRootOrShadowRoot(node)) {
            $wrapNodesImpl(selection, descendants, descendants.length, createElement, wrappingElement);
            descendants = [];
            topLevelNode = node;
        }
        else if (topLevelNode === null
            || (topLevelNode !== null && $hasAncestor(node, topLevelNode))) {
            descendants.push(node);
        }
        else {
            $wrapNodesImpl(selection, descendants, descendants.length, createElement, wrappingElement);
            descendants = [node];
        }
    }
    $wrapNodesImpl(selection, descendants, descendants.length, createElement, wrappingElement);
}
function $wrapNodesImpl(selection, nodes, nodesLength, createElement, wrappingElement = null) {
    if (nodes.length === 0)
        return;
    const firstNode = nodes[0];
    const elementMapping = new Map();
    const elements = [];
    // The below logic is to find the right target for us to
    // either insertAfter/insertBefore/append the corresponding
    // elements to. This is made more complicated due to nested
    // structures.
    let target = $isElementNode(firstNode)
        ? firstNode
        : firstNode.getParentOrThrow();
    if (target.isInline())
        target = target.getParentOrThrow();
    let targetIsPrevSibling = false;
    while (target !== null) {
        const prevSibling = target.getPreviousSibling();
        if (prevSibling !== null) {
            target = prevSibling;
            targetIsPrevSibling = true;
            break;
        }
        target = target.getParentOrThrow();
        if ($isRootOrShadowRoot(target))
            break;
    }
    const emptyElements = new Set();
    // Find any top level empty elements
    for (let i = 0; i < nodesLength; i++) {
        const node = nodes[i];
        if ($isElementNode(node) && node.getChildrenSize() === 0)
            emptyElements.add(node.getKey());
    }
    const movedNodes = new Set();
    // Move out all leaf nodes into our elements array.
    // If we find a top level empty element, also move make
    // an element for that.
    for (let i = 0; i < nodesLength; i++) {
        const node = nodes[i];
        let parent = node.getParent();
        if (parent !== null && parent.isInline())
            parent = parent.getParent();
        if (parent !== null
            && $isLeafNode(node)
            && !movedNodes.has(node.getKey())) {
            const parentKey = parent.getKey();
            if (elementMapping.get(parentKey) === undefined) {
                const targetElement = createElement();
                targetElement.setFormat(parent.getFormatType());
                targetElement.setIndent(parent.getIndent());
                elements.push(targetElement);
                elementMapping.set(parentKey, targetElement);
                // Move node and its siblings to the new
                // element.
                parent.getChildren().forEach((child) => {
                    targetElement.append(child);
                    movedNodes.add(child.getKey());
                    if ($isElementNode(child)) {
                        // Skip nested leaf nodes if the parent has already been moved
                        child.getChildrenKeys().forEach(key => movedNodes.add(key));
                    }
                });
                $removeParentEmptyElements(parent);
            }
        }
        else if (emptyElements.has(node.getKey())) {
            const targetElement = createElement();
            targetElement.setFormat(node.getFormatType());
            targetElement.setIndent(node.getIndent());
            elements.push(targetElement);
            node.remove(true);
        }
    }
    if (wrappingElement !== null) {
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            wrappingElement.append(element);
        }
    }
    let lastElement = null;
    // If our target is Root-like, let's see if we can re-adjust
    // so that the target is the first child instead.
    if ($isRootOrShadowRoot(target)) {
        if (targetIsPrevSibling) {
            if (wrappingElement !== null) {
                target.insertAfter(wrappingElement);
            }
            else {
                for (let i = elements.length - 1; i >= 0; i--) {
                    const element = elements[i];
                    target.insertAfter(element);
                }
            }
        }
        else {
            const firstChild = target.getFirstChild();
            if ($isElementNode(firstChild))
                target = firstChild;
            if (firstChild === null) {
                if (wrappingElement) {
                    target.append(wrappingElement);
                }
                else {
                    for (let i = 0; i < elements.length; i++) {
                        const element = elements[i];
                        target.append(element);
                        lastElement = element;
                    }
                }
            }
            else {
                if (wrappingElement !== null) {
                    firstChild.insertBefore(wrappingElement);
                }
                else {
                    for (let i = 0; i < elements.length; i++) {
                        const element = elements[i];
                        firstChild.insertBefore(element);
                        lastElement = element;
                    }
                }
            }
        }
    }
    else {
        if (wrappingElement) {
            target.insertAfter(wrappingElement);
        }
        else {
            for (let i = elements.length - 1; i >= 0; i--) {
                const element = elements[i];
                target.insertAfter(element);
                lastElement = element;
            }
        }
    }
    const prevSelection = $getPreviousSelection();
    if ($isRangeSelection(prevSelection)
        && isPointAttached(prevSelection.anchor)
        && isPointAttached(prevSelection.focus))
        $setSelection(prevSelection.clone());
    else if (lastElement !== null)
        lastElement.selectEnd();
    else
        selection.dirty = true;
}
function $isRootOrShadowRoot(node) {
    return $isRootNode(node) || ($isElementNode(node) && node.isShadowRoot());
}
function $removeParentEmptyElements(startingNode) {
    var _a;
    let node = startingNode;
    while (node !== null && !$isRootNode(node)) {
        const latest = node.getLatest();
        const parentNode = node.getParent();
        if (((_a = latest.__children) === null || _a === void 0 ? void 0 : _a.length) === 0)
            node.remove(true);
        node = parentNode;
    }
}
function $hasAncestor(child, targetNode) {
    let parent = child.getParent();
    while (parent !== null) {
        if (parent.is(targetNode))
            return true;
        parent = parent.getParent();
    }
    return false;
}
function isPointAttached(point) {
    return point.getNode().isAttached();
}

function useSlashMenuPlugin(props) {
    var _a;
    const editor = useEditor();
    const rootContainer = ref();
    const data = ref({
        isShow: false,
        top: 0,
        left: 0,
    });
    const dropdownMenu = ref();
    let unregister;
    const defaultBlockFormats = [
        {
            key: 'Paragraph',
            wordsToSearch: ['段落', 'duanluo', 'dl'],
            name: 'Paragraph',
            className: 'format_paragraph',
            transform: (editor, selection) => $wrapNodes(selection, () => {
                return $createParagraphNode();
            }),
        },
        {
            key: 'Heading 1',
            wordsToSearch: ['一级标题', 'yijibiaoti', 'yjbt'],
            name: 'Heading 1',
            className: 'format_heading1',
            transform: (editor, selection) => $wrapNodes(selection, () => {
                return $createHeadingNode('h1');
            }),
        },
        {
            key: 'Heading 2',
            wordsToSearch: ['二级标题', 'erjibiaoti', 'ejbt'],
            name: 'Heading 2',
            className: 'format_heading2',
            transform: (editor, selection) => $wrapNodes(selection, () => {
                return $createHeadingNode('h2');
            }),
        },
        {
            key: 'Heading 3',
            wordsToSearch: ['三级标题', 'sanjibiaoti', 'sjbt'],
            name: 'Heading 3',
            className: 'format_heading3',
            transform: (editor, selection) => $wrapNodes(selection, () => {
                return $createHeadingNode('h3');
            }),
        },
        {
            key: 'Heading 4',
            wordsToSearch: ['四级标题', 'sijibiaoti', 'sjbt'],
            name: 'Heading 4',
            className: 'format_heading4',
            transform: (editor, selection) => $wrapNodes(selection, () => {
                return $createHeadingNode('h4');
            }),
        },
        {
            key: 'Heading 5',
            wordsToSearch: ['五级标题', 'wujibiaoti', 'wjbt'],
            name: 'Heading 5',
            className: 'format_heading5',
            transform: (editor, selection) => $wrapNodes(selection, () => {
                return $createHeadingNode('h5');
            }),
        },
        {
            key: 'Heading 6',
            wordsToSearch: ['六级标题', 'liujibiaoti', 'ljbt'],
            name: 'Heading 6',
            className: 'format_heading6',
            transform: (editor, selection) => $wrapNodes(selection, () => {
                return $createHeadingNode('h6');
            }),
        },
        {
            key: 'Quote',
            wordsToSearch: ['引用文本', 'yinyongwenben', 'yywb'],
            name: 'Quote',
            className: 'format_quote',
            transform: (editor, selection) => $wrapNodes(selection, () => {
                return $createQuoteNode();
            }),
        },
        {
            key: 'Unordered list',
            wordsToSearch: ['无序列表', 'wuxuliebiao', 'wxlb'],
            name: 'Unordered list',
            className: 'format_ul',
            transform: (editor, selection) => {
                insertList(editor, 'bullet');
            },
        },
        {
            key: 'Ordered list',
            wordsToSearch: ['有序列表', 'youxuliebiao', 'yxlb'],
            name: 'Ordered list',
            className: 'format_ol',
            transform: (editor, selection) => {
                insertList(editor, 'number');
            },
        },
        {
            key: 'Check list',
            wordsToSearch: ['待办事项', 'daibanshixiang', 'dbsx'],
            name: 'Check list',
            className: 'format_todo',
            transform: (editor, selection) => {
                insertList(editor, 'check');
            },
        },
        {
            key: 'BlockCode',
            wordsToSearch: ['代码块', 'daimakuai', 'dmk'],
            name: 'BlockCode',
            className: 'format_block_code',
            // @ts-expect-error
            transform: (editor, selection) => $wrapNodes(selection, (targetNode) => {
                return $createCodeNode();
            }),
        },
        // {
        //   key: 'Latex',
        //   chineseKey: '公式块',
        //   chinesePinyinKey: 'gongshikuai',
        //   initialLetterOfChinesePinyinKey: 'gsk',
        //   name: t('format.formula'),
        //   className: 'format_formula',
        //   transform: (editor: LexicalEditor, selection: RangeSelection) => $wrapNodes(selection, (targetNode: ElementNode) => {
        //     const p = $createParagraphNode()
        //     const latex = $createLatexNode()
        //     latex.setEditing(true)
        //     p.append(latex)
        //     return p
        //   }),
        // },
    ];
    const blockFormats = (_a = props.blockFormats) !== null && _a !== void 0 ? _a : defaultBlockFormats;
    const filterBlockFormats = ref(blockFormats);
    ref(false);
    let slashElementNodeKey;
    const searchKeyword = ref('');
    /**
     * 斜杠的偏移量，所以去搜索关键词的时候得+1
     */
    let startOffset = -1;
    // 这里先放着
    // let errorEndOffset = -1
    // region 方法
    const hasAnyModify = (event) => {
        const { shiftKey, ctrlKey, metaKey, altKey } = event;
        return shiftKey || ctrlKey || metaKey || altKey;
    };
    // endregion
    /**
     * 触发方式只有一种，按下/
     * 取消方式：
     * 1. 鼠标点击任意处
     * 2. 光标移出该行
     * 3. 输入文字搜索不到结果后再输入三个字符就不再显示
     */
    /**
     * TODO CTRL+COMMAND的效果
     * @param index
     */
    const onChoose = (index) => {
        if (!slashElementNodeKey || filterBlockFormats.value[index] === undefined) {
            console.table({ slashElementNodeKey, 'filterBlockFormats.value[index]': filterBlockFormats.value[index] });
            return;
        }
        editor.update(() => {
            var _a;
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                const anchorKey = selection.anchor.key;
                const anchorNode = editor.getEditorState()._nodeMap.get(anchorKey);
                const elementNode = anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.getTopLevelElement();
                const textContent = elementNode === null || elementNode === void 0 ? void 0 : elementNode.getTextContent();
                const textContentLength = elementNode === null || elementNode === void 0 ? void 0 : elementNode.getTextContentSize();
                if (!anchorNode || !elementNode || !$isElementNode(elementNode) || !textContent || !textContentLength) {
                    console.table({ anchorNode, elementNode });
                    return;
                }
                if (textContent === '/') {
                    if ($isListNode(elementNode)) {
                        editor.dispatchCommand(DELETE_CHARACTER_COMMAND, true);
                        filterBlockFormats.value[index].transform(editor, selection);
                        const anchorKey = selection.anchor.key;
                        const anchorNode = editor.getEditorState()._nodeMap.get(anchorKey);
                        const elementNode_new = anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.getTopLevelElement();
                        if (elementNode_new) {
                            $getRoot().getChildren().forEach((node) => {
                                var _a;
                                if (node.__key === elementNode_new.__key)
                                    node && node.getNextSibling() && ((_a = node.getNextSibling()) === null || _a === void 0 ? void 0 : _a.selectEnd());
                            });
                        }
                    }
                    else {
                        editor.dispatchCommand(DELETE_CHARACTER_COMMAND, true);
                        filterBlockFormats.value[index].transform(editor, selection);
                    }
                }
                else if ((textContent === null || textContent === void 0 ? void 0 : textContent.startsWith('/')) || (textContent === null || textContent === void 0 ? void 0 : textContent.startsWith('、'))) {
                    const isWordOrChar = textContent.lastIndexOf('/') === textContentLength - 1;
                    const textIndex = isWordOrChar ? textContent.lastIndexOf('/') - 1 : textContent.lastIndexOf('/');
                    let textIndexLength = textContent.substring(0, textIndex).length + 1;
                    let textNodeLength = textContent.substring(0, textIndex).length + 1;
                    isWordOrChar ? editor.dispatchCommand(DELETE_CHARACTER_COMMAND, true) : editor.dispatchCommand(DELETE_WORD_COMMAND, true);
                    while (textIndexLength !== 0) {
                        editor.dispatchCommand(INSERT_PARAGRAPH_COMMAND, undefined);
                        // @ts-expect-error
                        editor.dispatchCommand(MOVE_TO_END, undefined);
                        editor.dispatchCommand(DELETE_LINE_COMMAND, true);
                        --textIndexLength;
                    }
                    const newAnchorKey2 = editor.getEditorState()._nodeMap.get($getSelection().anchor.key);
                    while (textNodeLength !== 0) {
                        !!(newAnchorKey2 === null || newAnchorKey2 === void 0 ? void 0 : newAnchorKey2.getNextSibling()) && ((_a = newAnchorKey2.getNextSibling()) === null || _a === void 0 ? void 0 : _a.remove());
                        --textNodeLength;
                    }
                    filterBlockFormats.value[index].transform(editor, $getSelection());
                }
                else {
                    editor.dispatchCommand(DELETE_CHARACTER_COMMAND, true);
                    // @ts-expect-error
                    editor.dispatchCommand(MOVE_TO_END, undefined);
                    editor.dispatchCommand(INSERT_PARAGRAPH_COMMAND, undefined);
                    if ($isListNode(anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.getTopLevelElement())) {
                        editor.dispatchCommand(INSERT_PARAGRAPH_COMMAND, undefined);
                    }
                    filterBlockFormats.value[index].transform(editor, selection);
                }
                data.value.isShow = false;
            }
        });
    };
    const onHide = () => {
        data.value.isShow = false;
        slashElementNodeKey = undefined;
        searchKeyword.value = '';
        startOffset = -1;
        // errorEndOffset = -1
    };
    watch$1(() => searchKeyword.value, () => {
        if (searchKeyword.value === '') {
            filterBlockFormats.value = blockFormats;
            return;
        }
        filterBlockFormats.value = blockFormats.filter((b) => {
            return [b.key, ...b.wordsToSearch].some((word) => word.toLowerCase().includes(searchKeyword.value.toLowerCase()));
            // if (locale.value.startsWith('zh-')) {
            //   return b.chineseKey.includes(searchKeyword.value) || b.chinesePinyinKey.includes(searchKeyword.value) || b.initialLetterOfChinesePinyinKey.includes(searchKeyword.value)
            // } else {
            //   return b.key.toLowerCase().includes(searchKeyword.value.toLowerCase())
            // }
        });
        /* if(filterBlockFormats.value.length === 0 && errorEndOffset === -1){
          errorEndOffset = editor.getEditorState().read(() => {
            const sel = $getSelection()
            if(!$isRangeSelection(sel)){
              return -1
            }
            return sel.focus.offset
          })
        }else if(filterBlockFormats.value.length > 0){
          errorEndOffset = -1
        }
        console.log("errorEndOffset", errorEndOffset, 'searchKeyword.value.length', searchKeyword.value.length, 'startOffset', startOffset);
        if(errorEndOffset > -1 && searchKeyword.value.length - (errorEndOffset - startOffset) >= 3){
          onHide()
        } */
    });
    const onKeydown = (keyboardEvent) => {
        let isProcess = false;
        if (keyboardEvent.key === '/' && !hasAnyModify(keyboardEvent))
            isProcess = true;
        // windows上输入、的时候，key为Process，code可能为Slash或Backslash
        // if (keyboardEvent.key === 'Process'
        //     && (keyboardEvent.code === 'Slash' || keyboardEvent.code === 'Backslash')
        //     && !hasAnyModify(keyboardEvent))
        //   isProcess = true
        // if (keyboardEvent.key === '、' && !hasAnyModify(keyboardEvent))
        //   isProcess = true
        if (!isProcess)
            return;
        const offset = editor.getEditorState().read(() => {
            var _a;
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                const anchorKey = selection.anchor.key;
                const anchorNode = $getNodeByKey(anchorKey);
                const elementNode = anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.getTopLevelElement();
                if (!$isElementNode(elementNode))
                    return;
                if ((anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.getKey()) === elementNode.getKey())
                    return anchorNode.getTextContentSize();
                // 给一个空的段落输入时
                if (elementNode.getChildrenSize() === 0)
                    return 0;
                let offset = 0;
                for (let i = 0; i < elementNode.getChildrenSize(); i++) {
                    if (((_a = elementNode.getChildAtIndex(i)) === null || _a === void 0 ? void 0 : _a.getKey()) === anchorKey)
                        return offset + selection.anchor.offset;
                    offset += elementNode.getChildAtIndex(i).getTextContentSize();
                }
            }
        });
        const elementNode = editor.getEditorState().read(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                const anchorKey = selection.anchor.key;
                const anchorNode = $getNodeByKey(anchorKey);
                const elementNode = anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.getTopLevelElement();
                if ($isElementNode(elementNode))
                    return elementNode;
            }
        });
        if (!elementNode || offset === undefined) {
            console.warn('没有elementNode和offset', elementNode, offset);
            return;
        }
        const textContent = editor.getEditorState().read(() => {
            return elementNode.getTextContent();
        });
        startOffset = offset;
        searchKeyword.value = textContent.substring(offset + 1);
        // 这里加上了延时，那么在366行的判断才不会为空，才不会隐藏下拉菜单，最后导致slashElementNodeKey为undefined
        setTimeout(() => {
            var _a;
            slashElementNodeKey = elementNode.__key;
            data.value.isShow = true;
            const range = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.getRangeAt(0);
            const rootRect = editor.getRootElement().getBoundingClientRect();
            const editorInner = editor.getRootElement().closest('.editor-inner');
            const scaleY = editorInner.getBoundingClientRect().height / editorInner.offsetHeight;
            if (!range)
                return;
            const element = editor.getElementByKey(elementNode.__key);
            if (!element)
                return;
            const yOffset = element.getBoundingClientRect().height;
            const top = range.getBoundingClientRect().top + yOffset - rootRect.top;
            const left = range.getBoundingClientRect().left - rootRect.left;
            const height = filterBlockFormats.value.length * 36 + 10;
            if (top + height > window.innerHeight) {
                // TODO 自动获取高度
                data.value.top = top - height - 20;
            }
            else {
                data.value.top = top;
            }
            data.value.top /= scaleY;
            data.value.left = left;
        }, 20);
    };
    onMounted(() => {
        var _a, _b;
        (_a = editor.getRootElement()) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', onKeydown);
        unregister = mergeRegister(editor.registerUpdateListener(({ tags, dirtyLeaves, editorState, prevEditorState }) => {
            if (!slashElementNodeKey)
                return;
            editor.update(() => {
                var _a;
                const sel = $getSelection();
                if (!$isRangeSelection(sel))
                    return;
                const key = (_a = sel.anchor.getNode().getTopLevelElement()) === null || _a === void 0 ? void 0 : _a.getKey();
                if (key !== slashElementNodeKey) {
                    onHide();
                    console.warn('hide dropdown menu');
                    return;
                }
                const anchorKey = sel.anchor.key;
                const anchorNode = $getNodeByKey(anchorKey);
                const elementNode = anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.getTopLevelElement();
                if (!$isElementNode(elementNode)) {
                    console.warn('not elementNode', elementNode);
                    return;
                }
                const textContent = elementNode.getTextContent();
                if (!textContent.substring(startOffset).startsWith('/') && !textContent.substring(startOffset).startsWith('、')) {
                    console.table({ textContent, startOffset });
                    onHide();
                    return;
                }
                searchKeyword.value = textContent.substring(startOffset + 1);
            });
        }));
        rootContainer.value = (_b = editor.getRootElement()) === null || _b === void 0 ? void 0 : _b.closest('.editor-container');
    });
    onUnmounted(() => {
        var _a;
        if (unregister)
            unregister();
        (_a = editor.getRootElement()) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', onKeydown);
    });
    return {
        data,
        dropdownMenu,
        rootContainer,
        editor,
        onChoose,
        blockFormats,
        filterBlockFormats
    };
}

function useTabIndentationPlugin() {
    const editor = useEditor();
    useMounted(() => {
        return editor.registerCommand(KEY_TAB_COMMAND, (event) => {
            const selection = $getSelection();
            if (!$isRangeSelection(selection))
                return false;
            event.preventDefault();
            return editor.dispatchCommand(event.shiftKey ? OUTDENT_CONTENT_COMMAND : INDENT_CONTENT_COMMAND, undefined);
        }, COMMAND_PRIORITY_EDITOR);
    });
}

function useDropdownMenu(props, emit) {
    // add 选中工具栏，需要新增办法判断hide逻辑
    // region 数据
    //   const emit = defineEmits<{
    //     (e: 'hide'): void
    //     (e: 'choose', index: number): void
    //   }>()
    const index = ref(0);
    const updateIndex = (i) => {
        index.value = i;
    };
    provide('index', {
        index,
        updateIndex,
    });
    const editor = useEditor();
    const dropdownMenu = ref();
    let itemCount = 0;
    // endregion
    // region 方法
    watch$1(() => props.isShow, () => {
        index.value = 0;
    });
    // endregion
    // region 事件
    const onKeydown = (e) => {
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey)
            return;
        if (e.key === 'ArrowUp') {
            onArrowUpOrDown(true);
            e.preventDefault();
            e.stopPropagation();
        }
        if (e.key === 'ArrowDown') {
            onArrowUpOrDown(false);
            e.preventDefault();
            e.stopPropagation();
        }
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            if (!e.isComposing)
                onEnter();
        }
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            onEsc();
        }
    };
    const onArrowUpOrDown = (isUp) => {
        var _a, _b;
        if ((_a = dropdownMenu.value) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.dropdown-menu-item'))
            itemCount = (_b = dropdownMenu.value) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.dropdown-menu-item').length;
        const oldIndex = index.value;
        let newIndex;
        if (isUp)
            newIndex = Math.max(0, index.value - 1);
        else
            newIndex = Math.min(itemCount - 1, index.value + 1);
        updateIndex(newIndex);
        onKeydownToUpdateIndex(newIndex, oldIndex);
    };
    const onEnter = () => {
        // 加上这个的话，editor.dispatchCommand(DELETE_CHARACTER_COMMAND, true);会无法生效
        /* const sel = window.getSelection()
        if(sel){
          sel.removeAllRanges()
          if(HandleHide.firstRange){
            sel.addRange(HandleHide.firstRange)
          }
        } */
        emit('choose', index.value);
        // emitter.emit(DOCUMENT_INSERT_BLOCK_TOOL_CHOOSE_COMMAND, index.value)
    };
    provide('onEnter', onEnter);
    const onEsc = () => {
        /* const sel = window.getSelection()
        if(sel){
          sel.removeAllRanges()
          if(HandleHide.firstRange){
            sel.addRange(HandleHide.firstRange)
          }
        } */
        emit('hide');
    };
    const onKeydownToUpdateIndex = (newIndex, oldIndex) => {
        var _a, _b, _c, _d;
        const element = (_a = dropdownMenu.value) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.dropdown-menu-item')[index.value];
        if (!element)
            return;
        const padding = 4;
        if (newIndex > oldIndex) {
            if (element.offsetTop + element.offsetHeight > dropdownMenu.value.offsetHeight) {
                (_b = dropdownMenu.value) === null || _b === void 0 ? void 0 : _b.scrollTo({
                    top: element.offsetTop - ((_c = dropdownMenu.value) === null || _c === void 0 ? void 0 : _c.offsetHeight) + element.offsetHeight + padding,
                    left: 0,
                    behavior: 'smooth', // 平滑滚动
                });
            }
        }
        else {
            if (element.offsetTop < dropdownMenu.value.scrollTop) {
                (_d = dropdownMenu.value) === null || _d === void 0 ? void 0 : _d.scrollTo({
                    top: element.offsetTop - padding,
                    left: 0,
                    behavior: 'smooth', // 平滑滚动
                });
            }
        }
    };
    // endregion
    class HandleHide {
        static register() {
            // 1. 按左右的时候关闭
            // 在onKeydown里已经实现
            /**
             * 不再用selectionchange是因为
             * 1. 点击块编辑器
             * 2. 设置对应节点的selected为true
             * 3. 重新createDOM
             * 导致意外地触发selectionchange，无法用range对象、外部的值来进行规避
             * 所以改为click
             *
             * 用selectionchange是因为如果用click，在文本中输入/的dropdown在选中项目后document.activeElement为body
             */
            if (props.hiddenOnSelectionChange) {
                // 2. range change的时候实现
                document.addEventListener('selectionchange', HandleHide.onSelectionChange);
            }
            if (props.hiddenOnClick) {
                // 2. click实现
                document.addEventListener('click', HandleHide.onClick);
            }
            if (props.hiddenOnRangeClick) {
                // 2. click实现
                document.addEventListener('click', HandleHide.onRangeClick);
            }
            // 3. editor要不响应ENTER
            HandleHide.unregister = mergeRegister(editor.registerCommand(KEY_ENTER_COMMAND, (event) => {
                if (event !== null)
                    event.preventDefault();
                return true;
            }, COMMAND_PRIORITY_LOW), editor.registerCommand(KEY_ESCAPE_COMMAND, (e) => {
                e.preventDefault();
                e.stopPropagation();
                onEsc();
                return true;
            }, COMMAND_PRIORITY_LOW), editor.registerCommand(KEY_ARROW_UP_COMMAND, (e) => {
                e.preventDefault();
                return true;
            }, COMMAND_PRIORITY_NORMAL), editor.registerCommand(KEY_ARROW_DOWN_COMMAND, (e) => {
                e.preventDefault();
                return true;
            }, COMMAND_PRIORITY_NORMAL));
        }
        static unRegister() {
            // 1. 按左右的时候关闭
            if (props.hiddenOnSelectionChange) {
                // 2. range change的时候实现
                document.removeEventListener('selectionchange', HandleHide.onSelectionChange);
            }
            if (props.hiddenOnClick) {
                // 2. click实现
                document.removeEventListener('click', HandleHide.onClick);
            }
            if (props.hiddenOnRangeClick) {
                // 2. click实现
                document.removeEventListener('click', HandleHide.onRangeClick);
            }
            // 3. editor要不响应ENTER
            HandleHide.unregister();
        }
        static onSelectionChange() {
            var _a, _b, _c;
            if (((_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.rangeCount) && window.getSelection().rangeCount > 0) {
                const currentRange = (_b = window.getSelection()) === null || _b === void 0 ? void 0 : _b.getRangeAt(0);
                if (currentRange && ((_c = document.querySelector('.dropdown-menu')) === null || _c === void 0 ? void 0 : _c.contains(currentRange.startContainer)))
                    return;
                if (currentRange !== HandleHide.firstRange)
                    emit('hide');
            }
        }
        static onClick(e) {
            console.log(e);
            if (e.target.closest('.dropdown-menu'))
                return;
            if (e.target.closest('.block-tool-btn'))
                return;
            emit('hide');
        }
        // 新增工具栏hide
        static onRangeClick(e) {
            if (e.target.closest('.dropdown-menu'))
                return;
            if (e.target.closest('.editor-container'))
                return;
            if (e.target.closest('.hover-toolbar-item'))
                return;
            if (e.target.closest('.hover-toolbar'))
                return;
            // if (e?.path[0]?.nodeName === 'HTML')
            //   return
            //
            // if (e.target?.className?.includes('app-container'))
            //   return;
            emit('hide');
        }
    }
    HandleHide.isFirst = true;
    onMounted(() => {
        var _a, _b;
        if (props.element) {
            props.element.addEventListener('keydown', onKeydown);
        }
        else {
            document.addEventListener('keydown', onKeydown);
        }
        HandleHide.register();
        if ((_a = dropdownMenu.value) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.dropdown-menu-item'))
            itemCount = (_b = dropdownMenu.value) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.dropdown-menu-item').length;
    });
    onUnmounted(() => {
        if (props.element) {
            props.element.removeEventListener('keydown', onKeydown);
        }
        else {
            document.removeEventListener('keydown', onKeydown);
        }
        HandleHide.unRegister();
    });
    return {
        dropdownMenu
    };
}

var script$e = {
  setup: function setup() {
    var editor = useEditor();
    var decorators = useDecorators(editor);
    return function () {
      return decorators.value;
    };
  }
};

/* script */
const __vue_script__$g = script$e;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div")
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;

  /* style */
  const __vue_inject_styles__$g = function (inject) {
    if (!inject) return
    inject("data-v-168c78ad_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalDecoratedTeleports.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$g = undefined;
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$g = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$d = {
  setup: function setup() {
    var editor = inject('editor');
    useRichTextSetup(editor);
    var showPlaceholder = useCanShowPlaceholder(editor);
    return {
      showPlaceholder: showPlaceholder
    };
  },
  components: {
    Decorators: __vue_component__$g
  }
};

/* script */
const __vue_script__$f = script$d;

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _vm.showPlaceholder ? _vm._t("placeholder") : _vm._e(),
      _vm._v(" "),
      _vm._t("contentEditable"),
      _vm._v(" "),
      _c("Decorators"),
    ],
    2
  )
};
var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;

  /* style */
  const __vue_inject_styles__$f = function (inject) {
    if (!inject) return
    inject("data-v-2a2f6272_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalRichTextPlugin.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$f = undefined;
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$c = {
  setup: function setup() {
    var rootRef = ref(null);
    var editor = useEditor();
    var editable = ref(true);
    useMounted(function () {
      if (rootRef.value) {
        editor.setRootElement(toRaw(rootRef.value));
        editable.value = editor.isEditable();
      }
      return editor.registerEditableListener(function (currentIsEditable) {
        editable.value = currentIsEditable;
      });
    });
    return {
      rootRef: rootRef,
      editable: editable
    };
  },
  props: {
    ariaActivedescendant: {
      type: String
    },
    ariaAutocomplete: {
      type: String,
      enum: ['none', 'inline', 'list', 'both']
    },
    ariaControls: {
      type: String
    },
    ariaDescribedby: {
      type: String
    },
    ariaExpanded: {
      type: Boolean
    },
    ariaLabel: {
      type: String
    },
    ariaLabelledby: {
      type: String
    },
    ariaMultiline: {
      type: Boolean
    },
    ariaOwns: {
      type: String
    },
    ariaRequired: {
      type: Boolean
    },
    autoCapitalize: {
      type: Boolean
    },
    autoComplete: {
      type: Boolean
    },
    autoCorrect: {
      type: Boolean
    },
    id: {
      type: String
    },
    role: {
      type: String,
      default: 'textbox'
    },
    spellcheck: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number
    },
    enableGrammarly: {
      type: Boolean
    }
  }
};

/* script */
const __vue_script__$e = script$c;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    ref: "rootRef",
    attrs: {
      id: _vm.id,
      "aria-activedescendant": !_vm.editable
        ? undefined
        : _vm.ariaActivedescendant,
      "aria-autocomplete": !_vm.editable ? undefined : _vm.ariaAutocomplete,
      "aria-controls": !_vm.editable ? undefined : _vm.ariaControls,
      "aria-describedby": _vm.ariaDescribedby,
      "aria-expanded": !_vm.editable
        ? undefined
        : _vm.role === "combobox"
        ? !!_vm.ariaExpanded
          ? _vm.ariaExpanded
          : undefined
        : undefined,
      "aria-label": _vm.ariaLabel,
      "aria-labelledby": _vm.ariaLabelledby,
      "aria-multiline": _vm.ariaMultiline,
      "aria-owns": !_vm.editable ? undefined : _vm.ariaOwns,
      "aria-required": _vm.ariaRequired,
      autocapitalize: "" + _vm.autoCapitalize,
      autocomplete: _vm.autoComplete,
      autocorrect: "" + _vm.autoCorrect,
      contenteditable: _vm.editable,
      role: !_vm.editable ? undefined : _vm.role,
      spellcheck: _vm.spellcheck,
      tabindex: _vm.tabindex,
    },
  })
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;

  /* style */
  const __vue_inject_styles__$e = function (inject) {
    if (!inject) return
    inject("data-v-792b1d64_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalContentEditable.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$e = undefined;
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$b = {
  props: {
    defaultSelection: {
      type: String,
      default: 'rootStart'
    }
  },
  setup: function setup(props) {
    var editor = useEditor();
    onMounted(function () {
      nextTick(function () {
        editor.focus(function () {
          var activeElement = document.activeElement;
          var rootElement = editor.getRootElement();
          if (rootElement !== null && (!activeElement || !rootElement.contains(activeElement))) {
            rootElement.focus({
              preventScroll: true
            });
          }
        }, {
          defaultSelection: props.defaultSelection
        });
      });
    });
  }
};

/* script */
const __vue_script__$d = script$b;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div")
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;

  /* style */
  const __vue_inject_styles__$d = undefined;
  /* scoped */
  const __vue_scope_id__$d = undefined;
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    undefined,
    undefined,
    undefined
  );

var script$a = {
  props: {
    matchers: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var editor = useEditor();
    onMounted(function () {
      useAutoLink(editor, props.matchers, function (url, prevUrl) {
        emit('change', {
          url: url,
          prevUrl: prevUrl
        });
      });
    });
    return {};
  }
};

/* script */
const __vue_script__$c = script$a;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div")
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;

  /* style */
  const __vue_inject_styles__$c = undefined;
  /* scoped */
  const __vue_scope_id__$c = undefined;
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    undefined,
    undefined,
    undefined
  );

var script$9 = {
  props: {
    transformers: {
      type: Array,
      default: function _default() {
        return _toConsumableArray(TRANSFORMERS);
      }
    }
  },
  setup: function setup(props) {
    var editor = useEditor();
    useMounted(function () {
      registerMarkdownShortcuts(editor, props.transformers);
    });
    return {};
  }
};

/* script */
const __vue_script__$b = script$9;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div")
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;

  /* style */
  const __vue_inject_styles__$b = undefined;
  /* scoped */
  const __vue_scope_id__$b = undefined;
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    undefined,
    undefined,
    undefined
  );

var script$8 = {
  /**
   * defineProps<{
   *   timeTravelButtonClassName: string
   *   timeTravelPanelSliderClassName: string
   *   timeTravelPanelButtonClassName: string
   *   timeTravelPanelClassName: string
   *   viewClassName: string
   * }>()
   */
  props: {
    viewClassName: {
      type: String
    },
    timeTravelButtonClassName: {
      type: String
    },
    timeTravelPanelSliderClassName: {
      type: String
    },
    timeTravelPanelButtonClassName: {
      type: String
    },
    timeTravelPanelClassName: {
      type: String
    }
  },
  setup: function setup() {
    var NON_SINGLE_WIDTH_CHARS_REPLACEMENT = Object.freeze({
      '\t': '\\t',
      '\n': '\\n'
    });
    var NON_SINGLE_WIDTH_CHARS_REGEX = new RegExp(Object.keys(NON_SINGLE_WIDTH_CHARS_REPLACEMENT).join('|'), 'g');
    var SYMBOLS = Object.freeze({
      ancestorHasNextSibling: '|',
      ancestorIsLastChild: ' ',
      hasNextSibling: '├',
      isLastChild: '└',
      selectedChar: '^',
      selectedLine: '>'
    });
    function printRangeSelection(selection) {
      var res = '';
      var formatText = printFormatProperties(selection);
      res += ": range ".concat(formatText !== '' ? "{ ".concat(formatText, " }") : '');
      var anchor = selection.anchor;
      var focus = selection.focus;
      var anchorOffset = anchor.offset;
      var focusOffset = focus.offset;
      res += "\n  \u251C anchor { key: ".concat(anchor.key, ", offset: ").concat(anchorOffset === null ? 'null' : anchorOffset, ", type: ").concat(anchor.type, " }");
      res += "\n  \u2514 focus { key: ".concat(focus.key, ", offset: ").concat(focusOffset === null ? 'null' : focusOffset, ", type: ").concat(focus.type, " }");
      return res;
    }
    function printObjectSelection(selection) {
      return ": node\n  \u2514 [".concat(Array.from(selection._nodes).join(', '), "]");
    }
    function printGridSelection(selection) {
      return ": grid\n  \u2514 { grid: ".concat(selection.gridKey, ", anchorCell: ").concat(selection.anchor.key, ", focusCell: ").concat(selection.focus.key, " }");
    }
    function generateContent(editorState) {
      var res = ' root\n';
      var selectionString = editorState.read(function () {
        var selection = $getSelection();
        visitTree($getRoot(), function (node, indent) {
          var nodeKey = node.getKey();
          var nodeKeyDisplay = "(".concat(nodeKey, ")");
          var typeDisplay = node.getType() || '';
          var isSelected = node.isSelected();
          var idsDisplay = $isMarkNode(node) ? " id: [ ".concat(node.getIDs().join(', '), " ] ") : '';
          res += "".concat(isSelected ? SYMBOLS.selectedLine : ' ', " ").concat(indent.join(' '), " ").concat(nodeKeyDisplay, " ").concat(typeDisplay, " ").concat(idsDisplay, " ").concat(printNode(node), "\n");
          res += printSelectedCharsLine({
            indent: indent,
            isSelected: isSelected,
            node: node,
            nodeKeyDisplay: nodeKeyDisplay,
            selection: selection,
            typeDisplay: typeDisplay
          });
        });
        return selection === null ? ': null' : $isRangeSelection(selection) ? printRangeSelection(selection) : DEPRECATED_$isGridSelection(selection) ? printGridSelection(selection) : printObjectSelection(selection);
      });
      return "".concat(res, "\n selection").concat(selectionString);
    }
    function visitTree(currentNode, visitor) {
      var indent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var childNodes = currentNode.getChildren();
      var childNodesLength = childNodes.length;
      childNodes.forEach(function (childNode, i) {
        visitor(childNode, indent.concat(i === childNodesLength - 1 ? SYMBOLS.isLastChild : SYMBOLS.hasNextSibling));
        if ($isElementNode(childNode)) {
          visitTree(childNode, visitor, indent.concat(i === childNodesLength - 1 ? SYMBOLS.ancestorIsLastChild : SYMBOLS.ancestorHasNextSibling));
        }
      });
    }
    function normalize(text) {
      return Object.entries(NON_SINGLE_WIDTH_CHARS_REPLACEMENT).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return acc.replace(new RegExp(key, 'g'), String(value));
      }, text);
    }
    function printNode(node) {
      if ($isTextNode(node)) {
        var text = node.getTextContent();
        var title = text.length === 0 ? '(empty)' : "\"".concat(normalize(text), "\"");
        var properties = printAllTextNodeProperties(node);
        return [title, properties.length !== 0 ? "{ ".concat(properties, " }") : null].filter(Boolean).join(' ').trim();
      } else if ($isLinkNode(node)) {
        var link = node.getURL();
        var _title = link.length === 0 ? '(empty)' : "\"".concat(normalize(link), "\"");
        var _properties = printAllLinkNodeProperties(node);
        return [_title, _properties.length !== 0 ? "{ ".concat(_properties, " }") : null].filter(Boolean).join(' ').trim();
      } else {
        return '';
      }
    }
    var FORMAT_PREDICATES = [function (node) {
      return node.hasFormat('bold') && 'Bold';
    }, function (node) {
      return node.hasFormat('code') && 'Code';
    }, function (node) {
      return node.hasFormat('italic') && 'Italic';
    }, function (node) {
      return node.hasFormat('strikethrough') && 'Strikethrough';
    }, function (node) {
      return node.hasFormat('subscript') && 'Subscript';
    }, function (node) {
      return node.hasFormat('superscript') && 'Superscript';
    }, function (node) {
      return node.hasFormat('underline') && 'Underline';
    }];
    var DETAIL_PREDICATES = [function (node) {
      return node.isDirectionless() && 'Directionless';
    }, function (node) {
      return node.isUnmergeable() && 'Unmergeable';
    }];
    var MODE_PREDICATES = [function (node) {
      return node.isToken() && 'Token';
    }, function (node) {
      return node.isSegmented() && 'Segmented';
    }];
    function printAllTextNodeProperties(node) {
      return [printFormatProperties(node), printDetailProperties(node), printModeProperties(node)].filter(Boolean).join(', ');
    }
    function printAllLinkNodeProperties(node) {
      return [printTargetProperties(node), printRelProperties(node)].filter(Boolean).join(', ');
    }
    function printDetailProperties(nodeOrSelection) {
      var str = DETAIL_PREDICATES.map(function (predicate) {
        return predicate(nodeOrSelection);
      }).filter(Boolean).join(', ').toLocaleLowerCase();
      if (str !== '') {
        str = "detail: ".concat(str);
      }
      return str;
    }
    function printModeProperties(nodeOrSelection) {
      var str = MODE_PREDICATES.map(function (predicate) {
        return predicate(nodeOrSelection);
      }).filter(Boolean).join(', ').toLocaleLowerCase();
      if (str !== '') {
        str = "mode: ".concat(str);
      }
      return str;
    }
    function printFormatProperties(nodeOrSelection) {
      var str = FORMAT_PREDICATES.map(function (predicate) {
        return predicate(nodeOrSelection);
      }).filter(Boolean).join(', ').toLocaleLowerCase();
      if (str !== '') {
        str = "format: ".concat(str);
      }
      return str;
    }
    function printTargetProperties(node) {
      var str = node.getTarget();
      if (str != null) {
        str = "target: ".concat(str);
      }
      return str;
    }
    function printRelProperties(node) {
      var str = node.getRel();
      if (str != null) {
        str = "rel: ".concat(str);
      }
      return str;
    }
    function printSelectedCharsLine(_ref3) {
      var indent = _ref3.indent,
        isSelected = _ref3.isSelected,
        node = _ref3.node,
        nodeKeyDisplay = _ref3.nodeKeyDisplay,
        selection = _ref3.selection,
        typeDisplay = _ref3.typeDisplay;
      if (!$isTextNode(node) || !$isRangeSelection(selection) || !isSelected || $isElementNode(node)) {
        return '';
      }
      var anchor = selection.anchor;
      var focus = selection.focus;
      if (node.getTextContent() === '' || anchor.getNode() === selection.focus.getNode() && anchor.offset === focus.offset) {
        return '';
      }
      var _$getSelectionStartEn = $getSelectionStartEnd(node, selection),
        _$getSelectionStartEn2 = _slicedToArray(_$getSelectionStartEn, 2),
        start = _$getSelectionStartEn2[0],
        end = _$getSelectionStartEn2[1];
      if (start === end) {
        return '';
      }
      var selectionLastIndent = indent[indent.length - 1] === SYMBOLS.hasNextSibling ? SYMBOLS.ancestorHasNextSibling : SYMBOLS.ancestorIsLastChild;
      var indentionChars = [].concat(_toConsumableArray(indent.slice(0, indent.length - 1)), [selectionLastIndent]);
      var unselectedChars = Array(start + 1).fill(' ');
      var selectedChars = Array(end - start).fill(SYMBOLS.selectedChar);
      var paddingLength = typeDisplay.length + 3;
      var nodePrintSpaces = Array(nodeKeyDisplay.length + paddingLength).fill(' ');
      return [SYMBOLS.selectedLine, indentionChars.join(' '), [].concat(_toConsumableArray(nodePrintSpaces), _toConsumableArray(unselectedChars), _toConsumableArray(selectedChars)).join('')].join(' ');
    }
    function $getSelectionStartEnd(node, selection) {
      var anchor = selection.anchor;
      var focus = selection.focus;
      var textContent = node.getTextContent();
      var textLength = textContent.length;
      var start = -1;
      var end = -1;
      if (anchor.type === 'text' && focus.type === 'text') {
        var anchorNode = anchor.getNode();
        var focusNode = focus.getNode();
        if (anchorNode === focusNode && node === anchorNode && anchor.offset !== focus.offset) {
          var _ref4 = anchor.offset < focus.offset ? [anchor.offset, focus.offset] : [focus.offset, anchor.offset];
          var _ref5 = _slicedToArray(_ref4, 2);
          start = _ref5[0];
          end = _ref5[1];
        } else if (node === anchorNode) {
          var _ref6 = anchorNode.isBefore(focusNode) ? [anchor.offset, textLength] : [0, anchor.offset];
          var _ref7 = _slicedToArray(_ref6, 2);
          start = _ref7[0];
          end = _ref7[1];
        } else if (node === focusNode) {
          var _ref8 = focusNode.isBefore(anchorNode) ? [focus.offset, textLength] : [0, focus.offset];
          var _ref9 = _slicedToArray(_ref8, 2);
          start = _ref9[0];
          end = _ref9[1];
        } else {
          start = 0;
          end = textLength;
        }
      }
      var numNonSingleWidthCharBeforeSelection = (textContent.slice(0, start).match(NON_SINGLE_WIDTH_CHARS_REGEX) || []).length;
      var numNonSingleWidthCharInSelection = (textContent.slice(start, end).match(NON_SINGLE_WIDTH_CHARS_REGEX) || []).length;
      return [start + numNonSingleWidthCharBeforeSelection, end + numNonSingleWidthCharBeforeSelection + numNonSingleWidthCharInSelection];
    }

    // Previously shown code...

    var editor = useEditor();
    var timeStampedEditorStates = ref([]);
    var content = ref('');
    var timeTravelEnabled = ref(false);
    var playingIndexRef = ref(0);
    var treeElementRef = ref(null);
    var inputRef = ref(null);
    var isPlaying = ref(false);
    var unregisterListener;
    watchEffect(function (onInvalidate) {
      content.value = generateContent(editor.getEditorState());
      unregisterListener = editor.registerUpdateListener(function (_ref10) {
        _ref10.editorState;
        var compositionKey = editor._compositionKey;
        var treeText = generateContent(editor.getEditorState());
        var compositionText = compositionKey !== null && "Composition key: ".concat(compositionKey);
        content.value = [treeText, compositionText].filter(Boolean).join('\n\n');
        /*if (!timeTravelEnabled.value) {
          timeStampedEditorStates.value.push([
            ...timeStampedEditorStates.value,
            [Date.now(), editorState],
          ]);
        }*/
      });

      onInvalidate(function () {
        unregisterListener();
      });
    });
    var totalEditorStates = computed(function () {
      return timeStampedEditorStates.value.length;
    });
    var timeoutId;

    /*watchEffect((onInvalidate) => {
      console.log('watchEffect2')
      if (isPlaying.value) {
        const play = () => {
          const currentIndex = playingIndexRef.value;
          if (currentIndex === totalEditorStates.value - 1) {
            isPlaying.value = false;
            return;
          }
          const currentTime = timeStampedEditorStates.value[currentIndex][0];
          const nextTime = timeStampedEditorStates.value[currentIndex + 1][0];
          const timeDiff = nextTime - currentTime;
          timeoutId = setTimeout(() => {
            playingIndexRef.value++;
            const index = playingIndexRef.value;
            const input = inputRef;
            if (input) {
              input.value = String(index);
            }
            editor.setEditorState(timeStampedEditorStates.value[index][1]);
            play();
          }, timeDiff);
        };
         play();
      }
       onInvalidate(() => {
        clearTimeout(timeoutId);
      });
    });*/

    watchEffect(function () {
      var element = treeElementRef.value;
      if (element) {
        element.__lexicalEditor = editor;
      }
    });
    onUnmounted(function () {
      unregisterListener();
      clearTimeout(timeoutId);
      var element = treeElementRef.value;
      if (element) {
        element.__lexicalEditor = null;
      }
    });
    function enableTimeTravel() {
      var rootElement = editor.getRootElement();
      if (rootElement !== null) {
        rootElement.contentEditable = 'false';
        playingIndexRef.value = totalEditorStates.value - 1;
        timeTravelEnabled.value = true;
      }
    }
    function updateEditorState(e) {
      var editorStateIndex = Number(e.target.value);
      var timeStampedEditorState = timeStampedEditorStates.value[editorStateIndex];
      if (timeStampedEditorState) {
        playingIndexRef.value = editorStateIndex;
        editor.setEditorState(timeStampedEditorState[1]);
      }
    }
    function exit() {
      var rootElement = editor.getRootElement();
      if (rootElement) {
        rootElement.contentEditable = 'true';
        var index = timeStampedEditorStates.value.length - 1;
        var timeStampedEditorState = timeStampedEditorStates.value[index];
        editor.setEditorState(timeStampedEditorState[1]);
        var input = inputRef.value;
        if (input) {
          input.value = String(index);
        }
        timeTravelEnabled.value = false;
        isPlaying.value = false;
      }
    }
    return {
      content: content,
      timeTravelEnabled: timeTravelEnabled,
      totalEditorStates: totalEditorStates,
      enableTimeTravel: enableTimeTravel,
      updateEditorState: updateEditorState,
      isPlaying: isPlaying,
      exit: exit
    };
  }
};

/* script */
const __vue_script__$a = script$8;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.viewClassName }, [
    !_vm.timeTravelEnabled && _vm.totalEditorStates > 2
      ? _c(
          "button",
          {
            class: _vm.timeTravelButtonClassName,
            on: { click: _vm.enableTimeTravel },
          },
          [_vm._v("\n    Time Travel\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("pre", { ref: "treeElementRef" }, [_vm._v(_vm._s(_vm.content))]),
    _vm._v(" "),
    _vm.timeTravelEnabled
      ? _c("div", { class: _vm.timeTravelPanelClassName }, [
          _c(
            "button",
            {
              class: _vm.timeTravelPanelButtonClassName,
              on: {
                click: function ($event) {
                  _vm.isPlaying = !_vm.isPlaying;
                },
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.isPlaying ? "Pause" : "Play") + "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("input", {
            ref: "inputRef",
            class: _vm.timeTravelPanelSliderClassName,
            attrs: { type: "range", min: "1", max: _vm.totalEditorStates - 1 },
            on: { input: _vm.updateEditorState },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              class: _vm.timeTravelPanelButtonClassName,
              on: { click: _vm.exit },
            },
            [_vm._v("\n      Exit\n    ")]
          ),
        ])
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;

  /* style */
  const __vue_inject_styles__$a = function (inject) {
    if (!inject) return
    inject("data-v-375884c6_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalTreeViewPlugin.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$a = undefined;
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$7 = {
  /**
   * const props = withDefaults(defineProps<{
   *   ignoreInitialChange?: boolean
   *   ignoreSelectionChange?: boolean
   *   modelValue?: string
   * }>(), {
   *   ignoreInitialChange: true,
   *   ignoreSelectionChange: false,
   * })
   */
  props: {
    ignoreInitialChange: {
      type: Boolean,
      default: true
    },
    ignoreSelectionChange: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var editor = useEditor();
    useMounted(function () {
      editor.registerUpdateListener(function (_ref2) {
        var editorState = _ref2.editorState,
          dirtyElements = _ref2.dirtyElements,
          dirtyLeaves = _ref2.dirtyLeaves,
          prevEditorState = _ref2.prevEditorState,
          tags = _ref2.tags;
        if (props.ignoreSelectionChange && dirtyElements.size === 0 && dirtyLeaves.size === 0) {
          return;
        }
        if (props.ignoreInitialChange && prevEditorState.isEmpty()) {
          return;
        }
        emit('change', editorState, editor, tags);
        editorState.read(function () {
          emit('update:modelValue', $getRoot().getTextContent());
        });
      });
    });
  }
};

/* script */
const __vue_script__$9 = script$7;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div")
};
var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;

  /* style */
  const __vue_inject_styles__$9 = function (inject) {
    if (!inject) return
    inject("data-v-20eaebc4_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalOnChangePlugin.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$9 = undefined;
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$6 = {
  setup: function setup(props) {
    var editor = useEditor();
    useHistory(editor, props.externalHistoryState);
  }
};

/* script */
const __vue_script__$8 = script$6;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div")
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

  /* style */
  const __vue_inject_styles__$8 = function (inject) {
    if (!inject) return
    inject("data-v-5d3d5fb0_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalHistoryPlugin.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$8 = undefined;
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$5 = {
  setup: function setup() {
    var editor = useEditor();
    useList(editor);
  }
};

/* script */
const __vue_script__$7 = script$5;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div")
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = function (inject) {
    if (!inject) return
    inject("data-v-6ae3f8e4_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalListPlugin.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$7 = undefined;
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    createInjector,
    undefined,
    undefined
  );

function useCheckList() {
    const editor = useEditor();
    let unregisterListener;
    onMounted(() => {
        unregisterListener = mergeRegister(editor.registerCommand(INSERT_CHECK_LIST_COMMAND, () => {
            insertList(editor, 'check');
            return true;
        }, COMMAND_PRIORITY_LOW), editor.registerCommand(KEY_ARROW_DOWN_COMMAND, (event) => {
            return handleArrownUpOrDown(event, editor, false);
        }, COMMAND_PRIORITY_LOW), editor.registerCommand(KEY_ARROW_UP_COMMAND, (event) => {
            return handleArrownUpOrDown(event, editor, true);
        }, COMMAND_PRIORITY_LOW), editor.registerCommand(KEY_ESCAPE_COMMAND, (event) => {
            const activeItem = getActiveCheckListItem();
            if (activeItem != null) {
                const rootElement = editor.getRootElement();
                if (rootElement != null)
                    rootElement.focus();
                return true;
            }
            return false;
        }, COMMAND_PRIORITY_LOW), editor.registerCommand(KEY_SPACE_COMMAND, (event) => {
            const activeItem = getActiveCheckListItem();
            if (activeItem != null && editor.isEditable()) {
                editor.update(() => {
                    const listItemNode = $getNearestNodeFromDOMNode(activeItem);
                    if ($isListItemNode(listItemNode)) {
                        event.preventDefault();
                        listItemNode.toggleChecked();
                    }
                });
                return true;
            }
            return false;
        }, COMMAND_PRIORITY_LOW), editor.registerCommand(KEY_ARROW_LEFT_COMMAND, (event) => {
            return editor.getEditorState().read(() => {
                const selection = $getSelection();
                if ($isRangeSelection(selection) && selection.isCollapsed()) {
                    const { anchor } = selection;
                    const isElement = anchor.type === 'element';
                    if (isElement || anchor.offset === 0) {
                        const anchorNode = anchor.getNode();
                        const elementNode = $findMatchingParent(anchorNode, node => $isElementNode(node) && !node.isInline());
                        if ($isListItemNode(elementNode)
                            && (isElement || elementNode.getFirstDescendant() === anchorNode)) {
                            const domNode = editor.getElementByKey(elementNode.__key);
                            if (domNode != null && domNode.getAttribute('role') === 'checkbox' && document.activeElement !== domNode) {
                                domNode.focus();
                                event.preventDefault();
                                return true;
                            }
                        }
                    }
                }
                return false;
            });
        }, COMMAND_PRIORITY_LOW), listenPointerDown());
    });
    onUnmounted(() => {
        unregisterListener();
    });
    let listenersCount = 0;
    function listenPointerDown() {
        var _a, _b;
        if (listenersCount++ === 0) {
            (_a = editor.getRootElement()) === null || _a === void 0 ? void 0 : _a.addEventListener('click', handleClick);
            (_b = editor.getRootElement()) === null || _b === void 0 ? void 0 : _b.addEventListener('pointerdown', handlePointerDown);
        }
        return () => {
            var _a, _b;
            if (--listenersCount === 0) {
                (_a = editor.getRootElement()) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', handleClick);
                (_b = editor.getRootElement()) === null || _b === void 0 ? void 0 : _b.removeEventListener('pointerdown', handlePointerDown);
            }
        };
    }
    function handleCheckItemEvent(event, callback) {
        const target = event.target;
        if (!(target instanceof HTMLElement)) {
            return;
        }
        // Ignore clicks on LI that have nested lists
        const firstChild = target.firstChild;
        if (firstChild != null
            && firstChild instanceof HTMLElement
            && (firstChild.tagName === 'UL' || firstChild.tagName === 'OL')) {
            return;
        }
        const parentNode = target.parentNode;
        // @ts-expect-error internal field
        if (!parentNode || parentNode.__lexicalListType !== 'check') {
            return;
        }
        const pageX = event.pageX;
        const rect = target.getBoundingClientRect();
        if (target.dir === 'rtl'
            ? pageX < rect.right && pageX > rect.right - 20
            : pageX > rect.left && pageX < rect.left + 20) {
            callback();
        }
    }
    function handleClick(event) {
        handleCheckItemEvent(event, () => {
            const domNode = event.target;
            const editor = findEditor(domNode);
            if (editor != null && editor.isEditable()) {
                editor.update(() => {
                    if (event.target) {
                        const node = $getNearestNodeFromDOMNode(domNode);
                        if ($isListItemNode(node)) {
                            domNode.focus();
                            node.toggleChecked();
                        }
                    }
                });
            }
        });
    }
    function handlePointerDown(event) {
        handleCheckItemEvent(event, () => {
            // Prevents caret moving when clicking on check mark
            event.preventDefault();
        });
    }
    function findEditor(target) {
        let node = target;
        while (node) {
            // @ts-expect-error internal field
            if (node.__lexicalEditor) {
                // @ts-expect-error internal field
                return node.__lexicalEditor;
            }
            node = node.parentNode;
        }
        return null;
    }
    function getActiveCheckListItem() {
        const activeElement = document.activeElement;
        return activeElement != null
            && activeElement.tagName === 'LI'
            && activeElement.parentNode != null
            // @ts-expect-error internal field
            && activeElement.parentNode.__lexicalListType === 'check'
            ? activeElement
            : null;
    }
    function findCheckListItemSibling(node, backward) {
        let sibling = backward ? node.getPreviousSibling() : node.getNextSibling();
        let parent = node;
        // Going up in a tree to get non-null sibling
        while (sibling == null && $isListItemNode(parent)) {
            // Get li -> parent ul/ol -> parent li
            parent = parent.getParentOrThrow().getParent();
            if (parent != null) {
                sibling = backward
                    ? parent.getPreviousSibling()
                    : parent.getNextSibling();
            }
        }
        // Going down in a tree to get first non-nested list item
        while ($isListItemNode(sibling)) {
            const firstChild = backward
                ? sibling.getLastChild()
                : sibling.getFirstChild();
            if (!$isListNode(firstChild)) {
                return sibling;
            }
            sibling = backward ? firstChild.getLastChild() : firstChild.getFirstChild();
        }
        return null;
    }
    function handleArrownUpOrDown(event, editor, backward) {
        const activeItem = getActiveCheckListItem();
        if (activeItem != null) {
            editor.update(() => {
                const listItem = $getNearestNodeFromDOMNode(activeItem);
                if (!$isListItemNode(listItem))
                    return;
                const nextListItem = findCheckListItemSibling(listItem, backward);
                if (nextListItem != null) {
                    nextListItem.selectStart();
                    const dom = editor.getElementByKey(nextListItem.__key);
                    if (dom != null) {
                        event.preventDefault();
                        setTimeout(() => {
                            dom.focus();
                        }, 0);
                    }
                }
            });
        }
        return false;
    }
}

var script$4 = {
  setup: function setup() {
    useCheckList();
  }
};

/* script */
const __vue_script__$6 = script$4;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div")
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  const __vue_inject_styles__$6 = function (inject) {
    if (!inject) return
    inject("data-v-759c4fe6_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalCheckListPlugin.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$6 = undefined;
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$3 = {
  setup: function setup() {
    useTabIndentationPlugin();
  }
};

/* script */
const __vue_script__$5 = script$3;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div")
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = function (inject) {
    if (!inject) return
    inject("data-v-7b56a1de_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalTabIndentationPlugin.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$2 = {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    hiddenOnClick: {
      type: Boolean,
      default: false
    },
    hiddenOnRangeClick: {
      type: Boolean,
      default: false
    },
    hiddenOnSelectionChange: {
      type: Boolean,
      default: false
    },
    element: {
      type: HTMLElement,
      default: undefined
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    return useDropdownMenu(props, emit);
  }
};

/* script */
const __vue_script__$4 = script$2;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "dropdownMenu", staticClass: "dropdown-menu absolute top-0 left-0" },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-22069f17_0", { source: "\n\n/*# sourceMappingURL=DropdownMenu.vue.map */", map: {"version":3,"sources":["DropdownMenu.vue"],"names":[],"mappings":";;AAEA,2CAA2C","file":"DropdownMenu.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$1 = {
  setup: function setup() {
    var _inject = inject('index'),
      index = _inject.index,
      updateIndex = _inject.updateIndex;
    var onEnter = inject('onEnter');
    var component = getCurrentInstance();
    var item = ref();
    var key = parseInt(component === null || component === void 0 ? void 0 : component.vnode.key);
    watch$1(index, function () {
      var _item$value;
      if (key === index) (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.scrollTo();
    });
    return {
      updateIndex: updateIndex,
      onEnter: onEnter,
      key: key,
      index: index
    };
  }
};

/* script */
const __vue_script__$3 = script$1;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      ref: "item",
      staticClass: "dropdown-menu-item",
      class: { "dropdown-menu-item-active": _vm.key === _vm.index },
      staticStyle: { "user-select": "none" },
      on: {
        mouseenter: function () {
          return _vm.updateIndex(_vm.key)
        },
        click: _vm.onEnter,
      },
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = function (inject) {
    if (!inject) return
    inject("data-v-02d18b5a_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"DropdownMenuItem.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$3 = "data-v-02d18b5a";
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    createInjector,
    undefined,
    undefined
  );

var script = {
  setup: function setup(props) {
    return useSlashMenuPlugin(props);
  },
  components: {
    DropdownMenu: __vue_component__$4,
    DropdownMenuItem: __vue_component__$3,
    Teleport: n
  }
};

/* script */
const __vue_script__$2 = script;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.data.isShow
    ? _c(
        "Teleport",
        { attrs: { to: _vm.rootContainer } },
        [
          _c(
            "DropdownMenu",
            {
              staticClass: "insert-block-menu",
              style: { top: _vm.data.top + "px", left: _vm.data.left + "px" },
              attrs: {
                "hidden-on-click": true,
                "hidden-on-selection-change": false,
                element: _vm.editor.getRootElement(),
              },
              on: {
                hide: function ($event) {
                  _vm.data.isShow = false;
                },
                choose: _vm.onChoose,
              },
            },
            [
              _vm.filterBlockFormats.length === 0
                ? _c("div", { staticClass: "no-result" }, [
                    _vm._v("\n      没有结果\n    "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.filterBlockFormats, function (blockFormat, index) {
                return _c(
                  "DropdownMenuItem",
                  { key: index, class: blockFormat.className },
                  [
                    _c(
                      "span",
                      { staticClass: "mr-auto dropdown-menu-item-title" },
                      [_vm._v(_vm._s(blockFormat.name))]
                    ),
                    _vm._v(" "),
                    blockFormat.wordsToShow
                      ? _c(
                          "span",
                          { staticClass: "dropdown-menu-item-subtitle" },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(blockFormat.wordsToShow) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = function (inject) {
    if (!inject) return
    inject("data-v-4e92d7e5_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"LexicalSlashMenuPlugin.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    createInjector,
    undefined,
    undefined
  );

/* script */
const __vue_script__$1 = script$2;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "dropdownMenu", staticClass: "dropdown-menu absolute top-0 left-0" },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-4e6f40e2_0", { source: "\n\n/*# sourceMappingURL=DropdownMenu.vue.map */", map: {"version":3,"sources":["DropdownMenu.vue"],"names":[],"mappings":";;AAEA,2CAA2C","file":"DropdownMenu.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

/* script */
const __vue_script__ = script$1;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      ref: "item",
      staticClass: "dropdown-menu-item",
      class: { "dropdown-menu-item-active": _vm.key === _vm.index },
      staticStyle: { "user-select": "none" },
      on: {
        mouseenter: function () {
          return _vm.updateIndex(_vm.key)
        },
        click: _vm.onEnter,
      },
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-04f50d68_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"DropdownMenuItem.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-04f50d68";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

class DividerNode extends ElementNode {
    static getType() {
        return 'divider';
    }
    static clone(node) {
        return new DividerNode(node.__key);
    }
    constructor(key) {
        super(key);
    }
    // View
    static importDOM() {
        return {
            hr: () => ({
                conversion: () => ({ node: $createDividerNode() }),
                priority: 0,
            }),
        };
    }
    createDOM(config, editor) {
        const hr = document.createElement('hr');
        hr.setAttribute('contenteditable', 'false');
        addClassNamesToElement(hr, config.theme.divider);
        return hr;
    }
    exportDOM() {
        return { element: document.createElement('hr') };
    }
    static importJSON(serializedNode) {
        const node = $createDividerNode();
        node.setFormat(serializedNode.format);
        node.setIndent(serializedNode.indent);
        node.setDirection(serializedNode.direction);
        return node;
    }
    exportJSON() {
        return Object.assign(Object.assign({}, super.exportJSON()), { type: 'divider', version: 1 });
    }
    // Mutation
    canIndent() {
        return false;
    }
    canInsertAfter(node) {
        return false;
    }
    canInsertTextAfter() {
        return false;
    }
    isInline() {
        return false;
    }
    getTextContent() {
        return '\n';
    }
}
function $createDividerNode() {
    return new DividerNode();
}
function $isDividerNode(node) {
    return node instanceof DividerNode;
}
const replaceWithBlock = (createNode) => {
    return (parentNode, children, match) => {
        const node = createNode(match);
        if ($isElementNode(node)) {
            node.append(...children);
        }
        parentNode.replace(node);
        if ($isElementNode(node)) {
            node.select(0, 0);
        }
    };
};
const DIVIDER = {
    dependencies: [DividerNode],
    export: (node) => {
        if (!$isDividerNode(node)) {
            return null;
        }
        return '---';
    },
    regExp: /^---\W?$/,
    replace: (parentNode, children, match, isImport) => {
        var _a, _b;
        const dividerNode = $createDividerNode();
        const func = replaceWithBlock(() => {
            return dividerNode;
        });
        func(parentNode, children, match, isImport);
        const root = $getRoot();
        if (((_a = root.getLastChild()) === null || _a === void 0 ? void 0 : _a.getKey()) === dividerNode.getKey() && !isImport) {
            const p = $createParagraphNode();
            p.select();
            root.append(p);
        }
        else {
            (_b = dividerNode.getNextSibling()) === null || _b === void 0 ? void 0 : _b.select(0, 0);
        }
        dividerNode.markDirty();
    },
    type: 'element',
};

var grinning = "😀";
var smiley = "😃";
var smile = "😄";
var grin = "😁";
var laughing = "😆";
var satisfied = "😆";
var sweat_smile = "😅";
var joy = "😂";
var wink = "😉";
var blush = "😊";
var innocent = "😇";
var heart_eyes = "😍";
var kissing_heart = "😘";
var kissing = "😗";
var kissing_closed_eyes = "😚";
var kissing_smiling_eyes = "😙";
var yum = "😋";
var stuck_out_tongue = "😛";
var stuck_out_tongue_winking_eye = "😜";
var stuck_out_tongue_closed_eyes = "😝";
var neutral_face = "😐";
var expressionless = "😑";
var no_mouth = "😶";
var smirk = "😏";
var unamused = "😒";
var relieved = "😌";
var pensive = "😔";
var sleepy = "😪";
var sleeping = "😴";
var mask = "😷";
var dizzy_face = "😵";
var sunglasses = "😎";
var confused = "😕";
var worried = "😟";
var open_mouth = "😮";
var hushed = "😯";
var astonished = "😲";
var flushed = "😳";
var frowning = "😦";
var anguished = "😧";
var fearful = "😨";
var cold_sweat = "😰";
var disappointed_relieved = "😥";
var cry = "😢";
var sob = "😭";
var scream = "😱";
var confounded = "😖";
var persevere = "😣";
var disappointed = "😞";
var sweat = "😓";
var weary = "😩";
var tired_face = "😫";
var rage = "😡";
var pout = "😡";
var angry = "😠";
var smiling_imp = "😈";
var smiley_cat = "😺";
var smile_cat = "😸";
var joy_cat = "😹";
var heart_eyes_cat = "😻";
var smirk_cat = "😼";
var kissing_cat = "😽";
var scream_cat = "🙀";
var crying_cat_face = "😿";
var pouting_cat = "😾";
var heart = "❤️";
var hand = "✋";
var raised_hand = "✋";
var v = "✌️";
var point_up = "☝️";
var fist_raised = "✊";
var fist = "✊";
var monkey_face = "🐵";
var cat = "🐱";
var cow = "🐮";
var mouse = "🐭";
var coffee = "☕";
var hotsprings = "♨️";
var anchor = "⚓";
var airplane = "✈️";
var hourglass = "⌛";
var watch = "⌚";
var sunny = "☀️";
var star = "⭐";
var cloud = "☁️";
var umbrella = "☔";
var zap = "⚡";
var snowflake = "❄️";
var sparkles = "✨";
var black_joker = "🃏";
var mahjong = "🀄";
var phone = "☎️";
var telephone = "☎️";
var envelope = "✉️";
var pencil2 = "✏️";
var black_nib = "✒️";
var scissors = "✂️";
var wheelchair = "♿";
var warning = "⚠️";
var aries = "♈";
var taurus = "♉";
var gemini = "♊";
var cancer = "♋";
var leo = "♌";
var virgo = "♍";
var libra = "♎";
var scorpius = "♏";
var sagittarius = "♐";
var capricorn = "♑";
var aquarius = "♒";
var pisces = "♓";
var heavy_multiplication_x = "✖️";
var heavy_plus_sign = "➕";
var heavy_minus_sign = "➖";
var heavy_division_sign = "➗";
var bangbang = "‼️";
var interrobang = "⁉️";
var question = "❓";
var grey_question = "❔";
var grey_exclamation = "❕";
var exclamation = "❗";
var heavy_exclamation_mark = "❗";
var wavy_dash = "〰️";
var recycle = "♻️";
var white_check_mark = "✅";
var ballot_box_with_check = "☑️";
var heavy_check_mark = "✔️";
var x = "❌";
var negative_squared_cross_mark = "❎";
var curly_loop = "➰";
var loop = "➿";
var part_alternation_mark = "〽️";
var eight_spoked_asterisk = "✳️";
var eight_pointed_black_star = "✴️";
var sparkle = "❇️";
var copyright = "©️";
var registered = "®️";
var tm = "™️";
var information_source = "ℹ️";
var m = "Ⓜ️";
var black_circle = "⚫";
var white_circle = "⚪";
var black_large_square = "⬛";
var white_large_square = "⬜";
var black_medium_square = "◼️";
var white_medium_square = "◻️";
var black_medium_small_square = "◾";
var white_medium_small_square = "◽";
var black_small_square = "▪️";
var white_small_square = "▫️";
var EmojiData = {
	grinning: grinning,
	smiley: smiley,
	smile: smile,
	grin: grin,
	laughing: laughing,
	satisfied: satisfied,
	sweat_smile: sweat_smile,
	joy: joy,
	wink: wink,
	blush: blush,
	innocent: innocent,
	heart_eyes: heart_eyes,
	kissing_heart: kissing_heart,
	kissing: kissing,
	kissing_closed_eyes: kissing_closed_eyes,
	kissing_smiling_eyes: kissing_smiling_eyes,
	yum: yum,
	stuck_out_tongue: stuck_out_tongue,
	stuck_out_tongue_winking_eye: stuck_out_tongue_winking_eye,
	stuck_out_tongue_closed_eyes: stuck_out_tongue_closed_eyes,
	neutral_face: neutral_face,
	expressionless: expressionless,
	no_mouth: no_mouth,
	smirk: smirk,
	unamused: unamused,
	relieved: relieved,
	pensive: pensive,
	sleepy: sleepy,
	sleeping: sleeping,
	mask: mask,
	dizzy_face: dizzy_face,
	sunglasses: sunglasses,
	confused: confused,
	worried: worried,
	open_mouth: open_mouth,
	hushed: hushed,
	astonished: astonished,
	flushed: flushed,
	frowning: frowning,
	anguished: anguished,
	fearful: fearful,
	cold_sweat: cold_sweat,
	disappointed_relieved: disappointed_relieved,
	cry: cry,
	sob: sob,
	scream: scream,
	confounded: confounded,
	persevere: persevere,
	disappointed: disappointed,
	sweat: sweat,
	weary: weary,
	tired_face: tired_face,
	rage: rage,
	pout: pout,
	angry: angry,
	smiling_imp: smiling_imp,
	smiley_cat: smiley_cat,
	smile_cat: smile_cat,
	joy_cat: joy_cat,
	heart_eyes_cat: heart_eyes_cat,
	smirk_cat: smirk_cat,
	kissing_cat: kissing_cat,
	scream_cat: scream_cat,
	crying_cat_face: crying_cat_face,
	pouting_cat: pouting_cat,
	heart: heart,
	hand: hand,
	raised_hand: raised_hand,
	v: v,
	point_up: point_up,
	fist_raised: fist_raised,
	fist: fist,
	monkey_face: monkey_face,
	cat: cat,
	cow: cow,
	mouse: mouse,
	coffee: coffee,
	hotsprings: hotsprings,
	anchor: anchor,
	airplane: airplane,
	hourglass: hourglass,
	watch: watch,
	sunny: sunny,
	star: star,
	cloud: cloud,
	umbrella: umbrella,
	zap: zap,
	snowflake: snowflake,
	sparkles: sparkles,
	black_joker: black_joker,
	mahjong: mahjong,
	phone: phone,
	telephone: telephone,
	envelope: envelope,
	pencil2: pencil2,
	black_nib: black_nib,
	scissors: scissors,
	wheelchair: wheelchair,
	warning: warning,
	aries: aries,
	taurus: taurus,
	gemini: gemini,
	cancer: cancer,
	leo: leo,
	virgo: virgo,
	libra: libra,
	scorpius: scorpius,
	sagittarius: sagittarius,
	capricorn: capricorn,
	aquarius: aquarius,
	pisces: pisces,
	heavy_multiplication_x: heavy_multiplication_x,
	heavy_plus_sign: heavy_plus_sign,
	heavy_minus_sign: heavy_minus_sign,
	heavy_division_sign: heavy_division_sign,
	bangbang: bangbang,
	interrobang: interrobang,
	question: question,
	grey_question: grey_question,
	grey_exclamation: grey_exclamation,
	exclamation: exclamation,
	heavy_exclamation_mark: heavy_exclamation_mark,
	wavy_dash: wavy_dash,
	recycle: recycle,
	white_check_mark: white_check_mark,
	ballot_box_with_check: ballot_box_with_check,
	heavy_check_mark: heavy_check_mark,
	x: x,
	negative_squared_cross_mark: negative_squared_cross_mark,
	curly_loop: curly_loop,
	loop: loop,
	part_alternation_mark: part_alternation_mark,
	eight_spoked_asterisk: eight_spoked_asterisk,
	eight_pointed_black_star: eight_pointed_black_star,
	sparkle: sparkle,
	copyright: copyright,
	registered: registered,
	tm: tm,
	information_source: information_source,
	m: m,
	black_circle: black_circle,
	white_circle: white_circle,
	black_large_square: black_large_square,
	white_large_square: white_large_square,
	black_medium_square: black_medium_square,
	white_medium_square: white_medium_square,
	black_medium_small_square: black_medium_small_square,
	white_medium_small_square: white_medium_small_square,
	black_small_square: black_small_square,
	white_small_square: white_small_square
};

class EmojiNode extends TextNode {
    static getType() {
        return 'emoji';
    }
    static clone(node) {
        return new EmojiNode(node.__text, node.__key);
    }
    constructor(text, key) {
        super(text, key);
    }
    createDOM(config) {
        const dom = document.createElement('span');
        const inner = document.createElement('span');
        inner.innerHTML = EmojiData[this.__text];
        inner.className = 'emoji-inner';
        dom.appendChild(inner);
        return dom;
    }
    updateDOM(prevNode, dom, config) {
        const inner = dom.firstChild;
        if (inner === null) {
            return true;
        }
        return false;
    }
    static importJSON(serializedNode) {
        const node = $createEmojiNode(serializedNode.text);
        node.setFormat(serializedNode.format);
        node.setDetail(serializedNode.detail);
        node.setMode(serializedNode.mode);
        node.setStyle(serializedNode.style);
        return node;
    }
    exportJSON() {
        return Object.assign(Object.assign({}, super.exportJSON()), { type: 'emoji' });
    }
    getTextContent() {
        return EmojiData[this.__text];
    }
}
function $isEmojiNode(node) {
    return node instanceof EmojiNode;
}
function $createEmojiNode(emojiText) {
    const node = new EmojiNode(emojiText).setMode('token');
    return $applyNodeReplacement(node);
}
const EMOJI = {
    dependencies: [EmojiNode],
    export: (node) => {
        if (!$isEmojiNode(node)) {
            return null;
        }
        return `:${node.__text}:`;
    },
    importRegExp: /:(.*?):/,
    regExp: /:(.*?):/,
    replace: (textNode, match) => {
        const [, text] = match;
        if (EmojiData[text]) {
            const emojiNode = $createEmojiNode(text);
            textNode.replace(emojiNode);
        }
    },
    trigger: ':',
    type: 'text-match'
};

// @ts-nocheck
function convertImageElement(domNode) {
    if (domNode instanceof HTMLImageElement) {
        const { alt: altText, src, width, height } = domNode;
        const node = $createImageNode({ altText, height, src, width });
        return { node };
    }
    return null;
}
class ImageNode extends TextNode {
    static getType() {
        return 'image';
    }
    static clone(node) {
        return new ImageNode(node.__src, node.__altText, node.__title, node.__maxWidth, node.__width, node.__height, node.__showCaption, node.__caption, node.__captionsEnabled, node.__key);
    }
    static importJSON(serializedNode) {
        const { altText, height, width, maxWidth, caption, src, showCaption, title } = serializedNode;
        const node = $createImageNode({
            altText,
            title,
            height,
            maxWidth,
            showCaption,
            src,
            width,
        });
        const nestedEditor = node.__caption;
        const editorState = nestedEditor.parseEditorState(caption.editorState);
        if (!editorState.isEmpty()) {
            nestedEditor.setEditorState(editorState);
        }
        return node;
    }
    exportDOM() {
        const element = document.createElement('img');
        element.setAttribute('src', this.__src);
        element.setAttribute('alt', this.__altText);
        element.setAttribute('title', this.__title);
        element.setAttribute('width', this.__width.toString());
        element.setAttribute('height', this.__height.toString());
        return { element };
    }
    static importDOM() {
        return {
            img: () => ({
                conversion: convertImageElement,
                priority: 0,
            }),
        };
    }
    constructor(src, altText, title, maxWidth, width, height, showCaption, caption, captionsEnabled, key) {
        super(key);
        this.__src = src;
        this.__title = title;
        this.__altText = altText;
        this.__maxWidth = maxWidth;
        this.__width = width || 'inherit';
        this.__height = height || 'inherit';
        this.__showCaption = showCaption || false;
        this.__caption = caption || createEditor();
        this.__captionsEnabled = captionsEnabled || captionsEnabled === undefined;
    }
    exportJSON() {
        return {
            altText: this.getAltText(),
            caption: this.__caption.toJSON(),
            height: this.__height === 'inherit' ? 0 : this.__height,
            maxWidth: this.__maxWidth,
            showCaption: this.__showCaption,
            src: this.getSrc(),
            type: 'image',
            version: 1,
            width: this.__width === 'inherit' ? 0 : this.__width,
        };
    }
    setWidthAndHeight(width, height) {
        const writable = this.getWritable();
        writable.__width = width;
        writable.__height = height;
    }
    setShowCaption(showCaption) {
        const writable = this.getWritable();
        writable.__showCaption = showCaption;
    }
    // View
    createDOM(config) {
        const span = document.createElement('span');
        span.setAttribute('contenteditable', 'false');
        const theme = config.theme;
        const className = theme.image;
        if (className !== undefined) {
            span.className = className;
        }
        const img = document.createElement('img');
        img.setAttribute('src', this.__src);
        img.setAttribute('alt', this.__altText);
        img.setAttribute('title', this.__title);
        span.append(img);
        return span;
    }
    updateDOM() {
        return false;
    }
    getSrc() {
        return this.__src;
    }
    getAltText() {
        return this.__altText;
    }
    getTextContent() {
        return this.getSrc();
    }
}
function $createImageNode({ altText, height, maxWidth = 500, captionsEnabled, src, width, showCaption, caption, key, title }) {
    const node = $applyNodeReplacement(new ImageNode(src, altText, title, maxWidth, width, height, showCaption, caption, captionsEnabled, key));
    node.setMode('token');
    return node;
}
function $isImageNode(node) {
    return node instanceof ImageNode;
}
const IMAGE = {
    dependencies: [ImageNode],
    export: (node, exportChildren, exportFormat) => {
        return `![${node.getAltText()}](${node.getUrl()})`;
    },
    importRegExp: /!\[(.*?)\]\((.*?)(\s".*?")?\)/,
    regExp: /!\[(.*?)\]\((.*?)(\s".*?")?\)/,
    replace: (textNode, match) => {
        const [_, altText, url, title] = match;
        const imageNode = $createImageNode({
            altText,
            src: url,
            title
        });
        textNode.replace(imageNode);
    },
    trigger: ')',
    type: 'text-match',
};

Vue.use(VueCompositionApi);
// export * as useSplashMenuPlugin from './composables/useSlashMenuPlugin'
// export * as useDropdownMenu from './composables/useDropdownMenu'
// export * as useTabIndentationPlugin from './composables/useTabIndentationPlugin'

export { $createDividerNode, $createEmojiNode, $createImageNode, $isDividerNode, $isEmojiNode, $isImageNode, DIVIDER, DividerNode, __vue_component__$1 as DropdownMenu, __vue_component__ as DropdownMenuItem, EMOJI, EmojiNode, IMAGE, ImageNode, __vue_component__$d as LexicalAutoFocusPlugin, __vue_component__$c as LexicalAutoLinkPlugin, __vue_component__$6 as LexicalCheckListPlugin, __vue_component__$h as LexicalComposer, __vue_component__$e as LexicalContentEditable, __vue_component__$8 as LexicalHistoryPlugin, __vue_component__$7 as LexicalListPlugin, __vue_component__$b as LexicalMarkdownShortcutPlugin, __vue_component__$9 as LexicalOnChangePlugin, __vue_component__$f as LexicalRichTextPlugin, __vue_component__$2 as LexicalSlashMenuPlugin, __vue_component__$5 as LexicalTabIndentationPlugin, __vue_component__$a as LexicalTreeViewPlugin, useAutoLink, useCanShowPlaceholder, useDecorators, useDropdownMenu, useEditor, useEffect, useHistory, useList, useMounted, useRichTextSetup, useSlashMenuPlugin, useTabIndentationPlugin };
